module.exports = __webpack_public_path__ + "media/Wind.1c2d433a.mp3";